<template>
  <div class="px-4 py-2">
    <div class="flex bg-gray-900 rounded-2xl p-2">
      <img class="w-24 h-24" :src="product.imgurl" @click="$emit('showImg')"
           @error="$event.target.src = require('@/assets/img/placeholder.png')">
      <div class="p-2 mr-2">
        <h1 class="text-white text-sm">{{ product.kala_Name }}</h1>
        <h5 class="text-gray-400 text-sm mt-3">
          قیمت:
          <!-- {{product.nerkh_With_Maliat / 10}} -->
          {{ $helper.priceFormatter(product.nerkh_With_Maliat) }}
        </h5>
        <h5 class="text-gray-400 text-sm mt-2">
          موجودی:
          <span class="text-green-500 font-bold">{{ product.mojodi }}</span>
        </h5>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HorizontalFoodCard",
  emits: ['showImg'],
  props: ['product'],
  methods: {
    test(e) {
      console.log("IMG: ", e)
    }
  }

}
</script>

<style scoped>

</style>